import { createSelector } from 'reselect'
import viewPropertiesSelector from '../viewPropertiesSelector'

const hideBuildabilityConflictLabelSelector = createSelector(
    viewPropertiesSelector,
    (viewProperties): boolean => (viewProperties?.['hideBuildabilityConflictLabel']) === 'true',
)

export default hideBuildabilityConflictLabelSelector
